import { Icon, Tag } from '@/components/ui';
import { useTranslation } from 'react-i18next';
import useLadyService from '@/services/LadyService';

const GirlCardIconsAndTags = ({ props }) => {
	const {
		gender,
		orientation,
		is_individual,
		is_healthy,
		is_verified,
		is_pornstar,
		is_new,
		tag_bdsm,
		healthy_at,
		verified_at,
		size,
	} = props;

	const { orientations, gendersTitle, getDayMonthYear } = useLadyService();

	const { t } = useTranslation('translation');

	const exists = is_individual || is_new || tag_bdsm || is_pornstar;

	return (
		<>
			{exists && <div className="d-flex gap-4">
				{!!is_individual && <Tag title={t('indireg')}>INDI</Tag>}
				{!!is_new && <Tag title={t('newmodel')}>NEW</Tag>}
				{!!tag_bdsm && <Tag title={t('bdsmservice')}>BDSM</Tag>}
				{!!is_pornstar && <Tag title={t('pornstar')}>STAR</Tag>}
			</div>}


			{!!verified_at ? (
				<Icon
					square
					clazz={'girl-card__icon verification'}
					spritePath={'verify-fill'}
					size={size ?? 'l'}
					title={`${t('verified')}. ${t('photosverified')}.  ${t(
						'lastcheck'
					)}: ${getDayMonthYear(verified_at, 'Europe/Prague')}`}
				/>
			) : null}

			{!!healthy_at ? (
				<Icon
					square
					clazz={'girl-card__icon verification'}
					spritePath={'health-fill'}
					size={size ?? 'l'}
					title={`${t('healthy')}. ${t('modeltests')}. ${t(
						'lastcheck'
					)}: ${getDayMonthYear(healthy_at, 'Europe/Prague')}`}
				/>
			) : null}
		</>
	);
};

export default GirlCardIconsAndTags;
